export default __webpack_public_path__ + "static/media/tutorial.7a5b5fb1.svg";